import { RootState, AppDispatch } from '@/store';
import { createListenerMiddleware } from '@reduxjs/toolkit';
import { creatorActions } from '../slices/creatorSlice';
import { UUID } from '@/types/types';

export const creatorListenerMiddleware = createListenerMiddleware();

creatorListenerMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.updateProduct,
	effect: async ({ payload }, listenerApi) => {
		listenerApi.cancelActiveListeners();
		await listenerApi.delay(500);

		listenerApi.dispatch(
			creatorActions.updateOptions({
				syncProjectCounter:
					listenerApi.getState().creator.options.syncProjectCounter + 1,
			})
		);
	},
});

creatorListenerMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.updateDimensions,
	effect: async ({ payload }, listenerApi) => {
		listenerApi.cancelActiveListeners();
		await listenerApi.delay(500);

		listenerApi.dispatch(
			creatorActions.updateOptions({
				syncProjectCounter:
					listenerApi.getState().creator.options.syncProjectCounter + 1,
			})
		);
	},
});

creatorListenerMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.setProductType,
	effect: async ({ payload }, listenerApi) => {
		for (const componentCategory of payload.componentCategories) {
			if (!componentCategory.chosenAttributeValues) continue;

			for (const [attributeId, selectedValue] of Object.entries(
				componentCategory.chosenAttributeValues
			)) {
				if (!selectedValue) continue;

				listenerApi.dispatch(
					creatorActions.changeSelectedAttributes({
						componentCategoryId: componentCategory.id,
						attributeId: attributeId as UUID,
						attributeValueId: selectedValue,
					})
				);
			}
		}
	},
});

creatorListenerMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.changeSelectedAttributes,
	effect: async ({ payload }, listenerApi) => {
		const components =
			listenerApi.getState().creator.components[payload.componentCategoryId];
		const selectedValues = Object.values(
			listenerApi.getState().creator.selectedAttributeValues[
				payload.componentCategoryId
			]
		);

		if (selectedValues.some((value) => !value)) return;

		let componentMatch = components.find((component) =>
			component.attributeValues.every((attributeValue) =>
				selectedValues.includes(attributeValue.id)
			)
		);

		if (!componentMatch) {
			componentMatch = components.find((component) =>
				component.attributeValues.some(
					(attributeValue) => attributeValue.id === payload.attributeValueId
				)
			);

			if (!componentMatch) return;

			listenerApi.dispatch(
				creatorActions.setSelectedValuesFromComponent({
					componentCategoryId: payload.componentCategoryId,
					component: componentMatch,
				})
			);
		}

		listenerApi.dispatch(
			creatorActions.changeSelectedComponent({
				componentCategoryId: payload.componentCategoryId,
				component: componentMatch,
			})
		);
	},
});
